export const BUTTON_HOVER_TOOLTIPS = {
    EXCEL_IMPORT_TITLE: "Click to import from Excel",
    IMPLEMENTED_TITLE: "Click for integration",
    NOT_IMPLEMENTED_TITLE: "Feature Not Yet Implemented. Click Below to Go to Classic App."
}